import styled from 'styled-components';

export const StyledEventInfo = styled.div``;
